module.exports = __webpack_public_path__ + "static/media/tutorial-dashboard-pin.d226d800.svg";